// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"adde15d0","245":"fa490ab4","626":"40947334","878":"ac4d556d","950":"15a27178"}[chunkId] + ".chunk.js";
};